import React from 'react';
import Auth from '../components/Auth/Auth';

const Admin = () => {
  return <Auth />;
};

export default Admin;
